import { cartActions } from 'actions';
import { useAddProductToCartMutation, useAddProductToRemoteCartMutation } from 'api';
import { Button } from 'components';
import { UNIVERSAL_PRODUCTS_KEY } from 'constants/cart';
import { sfEnabled } from 'constants/featureFlags';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useCart, useUser } from 'selectors';
import { User } from 'types';
import { CartItem, CartListType, CartPurchasable, CartState } from 'types/parts/cart';
import { generateAnalyticsEvent } from 'common/helpers/v1/analytics';
import { AnalyticsCategories, MaintenanceAnalyticEventActions } from 'constants/analytics';
import { ToastMsg } from 'common/components/Toast';
import { useTranslation } from 'react-i18next';
import { MaintenanceEventTableRow } from 'types/maintenance';
import { ComposeCartItem } from 'components/MachinePartsTable/CartHelp';


type Props = {
  maintenanceEvent?: MaintenanceEventTableRow;
  cartViewType: string;
  onSubmitClick: () => void;
  cartList: CartPurchasable[];
};
const AddtoCartBtn = ({
  cartViewType,
  maintenanceEvent,
  onSubmitClick,
  cartList
}: Props): JSX.Element => {
  const dispatch = useDispatch();
  const user = useUser() as User;
  const cart = useCart() as CartState;
  const { t } = useTranslation(['fpns']);

  const [addProductToCart] = useAddProductToCartMutation();
  const [AddProductToRemoteCart] = useAddProductToRemoteCartMutation();
  const addToCart =
    cartViewType === CartListType.VIEW_TYPE_LESS ? false : !cartList.some((item) => item.selected);
  const selectedItems = cartList.filter((cartItem) => cartItem.selected);

  const handleAddToCart = () => {
    /* TODO: make cart actions accept multiple items rather than using a loop here */
    for (const i of selectedItems) {
      try {
        if (sfEnabled()) {
          addProductToCart({
            accountId: user.plants[0],
            cart: cart,
            product: i.item,
            productId: i.item.sfProductId as string,
            quantity: i.quantity,
            machineId: i.groupId as string,
            machineDescription:
              i.groupId === undefined || i.groupId === UNIVERSAL_PRODUCTS_KEY
                ? UNIVERSAL_PRODUCTS_KEY
                : i.groupDescription
          });
        } else {
             AddProductToRemoteCart([ComposeCartItem(i.item, i.groupId as string, i.groupId as string)] as CartItem[])
                .unwrap()
                .then(() => {
                        // maintain temporay FE cartState to track cart count
                    dispatch({
                          type: cartActions.ADD_TO_CART,
                          item: i.item,
                          quantity: i.quantity,
                          groupId: i.groupId as string,
                          groupDescription:
                            i.groupId === undefined || i.groupId === UNIVERSAL_PRODUCTS_KEY
                              ? UNIVERSAL_PRODUCTS_KEY
                              : i.groupDescription
                  });
              })
                .catch((error) => {
                    console.warn('Error adding item to cart: ', error);
                });
        }
        generateAnalyticsEvent({
          category: AnalyticsCategories.MAINTENANCE,
          action: MaintenanceAnalyticEventActions.MAINTENANCE_EVENT_PARTS_KIT_ADDED_TO_CART,
          label: maintenanceEvent?.id
        });
      } catch (error) {
        console.warn('Add to cart failed! Error:', error);
        ToastMsg({
          heading: 'Error',
          message: t('error_add_to_cart', { item: i.item.sku }),
          type: 'error'
        });
      }
    }
    onSubmitClick();
  };
  return (
    <Button
      variant="primary"
      borderRadius="3rem"
      disabled={addToCart}
      width="7rem"
      onClick={handleAddToCart}
    >
      {t('add_to_cart')}
    </Button>
  );
};

export default AddtoCartBtn;
